import React from "react";
import { useState, useEffect } from 'react';
import { fetchWithAuth } from "../auth"

const ModifyMailDest = ({ isOpen, onClose, id, currentAddress}) => {

    async function updateMailDest() {
        await fetchWithAuth('/maildest', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, address: addressState })
        })
            .then(data => {
                setAddressState('')
                onClose()
            })
    }

    const [addressState, setAddressState] = useState('')
    useEffect(() => {
        setAddressState(currentAddress)
    }, [currentAddress]);
    const handleAddressChange = (event) => { setAddressState(event.target.value) }

    if (!isOpen) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    background: "white",
                    height: 300,
                    width: 600,
                    margin: "auto",
                    padding: "2%",
                    border: "2px solid #000",
                    borderRadius: "10px",
                    boxShadow: "2px solid black",
                }}
            >
                {/* {children} */}
                <table>
                    <tbody>
                        <tr>
                            <th className="title">indirizzo</th>
                        </tr>
                        <tr>
                            <td> <input type="text" value={addressState} onChange={handleAddressChange} /> </td>
                        </tr>
                    </tbody>
                </table>
                <button type="button" onClick={updateMailDest}>
                    Modifica
                </button>
                <button type="button" onClick={onClose}>
                    Chiudi
                </button>
            </div>
        </div>
    );
};

export default ModifyMailDest;
